import React from "react";

type Props = {
  children?: any;
};

function Paragraph({ children }: Props) {
  return (
    <p className="mb-10 leading-[2em] lg:text-[18px] font-regular whitespace-pre-line">
      {children}
    </p>
  );
}

export default Paragraph;
